/**
 * @generated SignedSource<<a049acdcf385165a80c2fd25d5e6a265>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateSlackUserInviteInput = {
  organizationId: string;
};
export type CreateSlackUserInviteButtonMutation$variables = {
  input: CreateSlackUserInviteInput;
};
export type CreateSlackUserInviteButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type CreateSlackUserInviteButtonMutation = {
  response: CreateSlackUserInviteButtonMutation$data;
  variables: CreateSlackUserInviteButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSlackUserInviteResponse",
    "kind": "LinkedField",
    "name": "createSlackUserInvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSlackUserInviteButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSlackUserInviteButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a60e8580b3eb37bec70c39e3db7ddbec",
    "id": null,
    "metadata": {},
    "name": "CreateSlackUserInviteButtonMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSlackUserInviteButtonMutation(\n  $input: CreateSlackUserInviteInput!\n) {\n  response: createSlackUserInvite(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0f57ceba47c58cf3def05c58780d0bb";

export default node;
